export default "__VITE_ASSET__DsUg09BG__"